module.exports = __webpack_public_path__ + "img/agreement-form.6946539d.gif";